import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import { CourseModule } from '@/store/modules/course'
  import type { PropType } from 'vue'
  import type { CourseGroupItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseProgressBar',
  props: {
    courseId: {
      required: true,
      type: String,
    },
    courseGroupId: String,
    combineCourseGroups: {
      default: false,
    },
    courseGroups: {
      type: Array as PropType<CourseGroupItem[]>,
      default: null,
    },
  },
  setup(__props) {

const props = __props;

  

  const completedModules = computed(() => {
    if (props.combineCourseGroups) {
      const states: boolean[] = []
      if (props.courseGroups.length) {
        props.courseGroups.forEach((group) => {
          states.push(...CourseModule.completedModuleStates(props.courseId, group.id))
        })
      } else {
        states.push(...CourseModule.completedModuleStates(props.courseId))
      }
      return states
    }
    return CourseModule.completedModuleStates(props.courseId, props.courseGroupId)
  })

  const numberOfModules = computed(() => {
    if (props.combineCourseGroups) {
      const states: number[] = []
      if (props.courseGroups.length) {
        props.courseGroups.forEach((group) => {
          states.push(CourseModule.numberOfCourseModules(props.courseId, group.id))
        })
      } else {
        states.push(CourseModule.numberOfCourseModules(props.courseId))
      }
      return states.reduce((acc, value) => {
        acc += value
        return acc
      }, 0)
    }
    return CourseModule.numberOfCourseModules(props.courseId, props.courseGroupId)
  })

return { __sfc: true,props, completedModules, numberOfModules, computed, CourseModule }
}

})